export const COUNTRIES = [
  { ID: 1, NAME: "Andorra", CODE: "AD" },
  { ID: 2, NAME: "United Arab Emirates", CODE: "AE" },
  { ID: 3, NAME: "Afghanistan", CODE: "AF" },
  { ID: 4, NAME: "Antigua and Barbuda", CODE: "AG" },
  { ID: 5, NAME: "Anguilla", CODE: "AI" },
  { ID: 6, NAME: "Albania", CODE: "AL" },
  { ID: 7, NAME: "Armenia", CODE: "AM" },
  { ID: 8, NAME: "Angola", CODE: "AO" },
  { ID: 9, NAME: "Argentina", CODE: "AR" },
  { ID: 10, NAME: "American Samoa", CODE: "AS" },
  { ID: 11, NAME: "Austria", CODE: "AT" },
  { ID: 12, NAME: "Australia", CODE: "AU" },
  { ID: 13, NAME: "Aruba", CODE: "AW" },
  { ID: 14, NAME: "Aland Islands", CODE: "AX" },
  { ID: 15, NAME: "Azerbaijan", CODE: "AZ" },
  { ID: 16, NAME: "Bosnia and Herzegovina", CODE: "BA" },
  { ID: 17, NAME: "Barbados", CODE: "BB" },
  { ID: 18, NAME: "Bangladesh", CODE: "BD" },
  { ID: 19, NAME: "Belgium", CODE: "BE" },
  { ID: 20, NAME: "Burkina Faso", CODE: "BF" },
  { ID: 21, NAME: "Bulgaria", CODE: "BG" },
  { ID: 22, NAME: "Bahrain", CODE: "BH" },
  { ID: 23, NAME: "Burundi", CODE: "BI" },
  { ID: 24, NAME: "Benin", CODE: "BJ" },
  { ID: 25, NAME: "Saint Barthélemy", CODE: "BL" },
  { ID: 26, NAME: "Bermuda", CODE: "BM" },
  { ID: 27, NAME: "Brunei Darussalam", CODE: "BN" },
  { ID: 28, NAME: "Bolivia, Plurinational State of", CODE: "BO" },
  { ID: 29, NAME: "Bonaire, Sint Eustatius and Saba", CODE: "BQ" },
  { ID: 30, NAME: "Brazil", CODE: "BR" },
  { ID: 31, NAME: "Bahamas", CODE: "BS" },
  { ID: 32, NAME: "Bhutan", CODE: "BT" },
  { ID: 33, NAME: "Bouvet Island", CODE: "BV" },
  { ID: 34, NAME: "Botswana", CODE: "BW" },
  { ID: 35, NAME: "Belarus", CODE: "BY" },
  { ID: 36, NAME: "Belize", CODE: "BZ" },
  { ID: 37, NAME: "Canada", CODE: "CA" },
  { ID: 38, NAME: "Cocos (Keeling) Islands", CODE: "CC" },
  { ID: 39, NAME: "Congo, the Democratic Republic of the", CODE: "CD" },
  { ID: 40, NAME: "Central African Republic", CODE: "CF" },
  { ID: 41, NAME: "Congo", CODE: "CG" },
  { ID: 42, NAME: "Switzerland", CODE: "CH" },
  { ID: 43, NAME: "Cote d'Ivoire", CODE: "CI" },
  { ID: 44, NAME: "Cook Islands", CODE: "CK" },
  { ID: 45, NAME: "Chile", CODE: "CL" },
  { ID: 46, NAME: "Cameroon", CODE: "CM" },
  { ID: 47, NAME: "China", CODE: "CN" },
  { ID: 48, NAME: "Colombia", CODE: "CO" },
  { ID: 49, NAME: "Costa Rica", CODE: "CR" },
  { ID: 50, NAME: "Chinese Taipei", CODE: "CT" },
  { ID: 51, NAME: "Cuba", CODE: "CU" },
  { ID: 52, NAME: "Cape Verde", CODE: "CV" },
  { ID: 53, NAME: "Curaçao", CODE: "CW" },
  { ID: 54, NAME: "Christmas Island", CODE: "CX" },
  { ID: 55, NAME: "Cyprus", CODE: "CY" },
  { ID: 56, NAME: "Czech Republic", CODE: "CZ" },
  { ID: 57, NAME: "Germany", CODE: "DE" },
  { ID: 58, NAME: "Djibouti", CODE: "DJ" },
  { ID: 59, NAME: "Denmark", CODE: "DK" },
  { ID: 60, NAME: "Dominican Republic", CODE: "DO" },
  { ID: 61, NAME: "Algeria", CODE: "DZ" },
  { ID: 62, NAME: "Ecuador", CODE: "EC" },
  { ID: 63, NAME: "Estonia", CODE: "EE" },
  { ID: 64, NAME: "Egypt", CODE: "EG" },
  { ID: 65, NAME: "Eritrea", CODE: "ER" },
  { ID: 66, NAME: "Spain", CODE: "ES" },
  { ID: 67, NAME: "Ethiopia", CODE: "ET" },
  { ID: 68, NAME: "Finland", CODE: "FI" },
  { ID: 69, NAME: "Fiji", CODE: "FJ" },
  { ID: 70, NAME: "France", CODE: "FR" },
  { ID: 71, NAME: "United Kingdom", CODE: "GB" },
  { ID: 72, NAME: "Grenada", CODE: "GD" },
  { ID: 73, NAME: "Georgia", CODE: "GE" },
  { ID: 74, NAME: "Ghana", CODE: "GH" },
  { ID: 75, NAME: "Guinea", CODE: "GN" },
  { ID: 76, NAME: "Guadeloupe", CODE: "GP" },
  { ID: 77, NAME: "Greece", CODE: "GR" },
  { ID: 78, NAME: "Guatemala", CODE: "GT" },
  { ID: 79, NAME: "Guyana", CODE: "GY" },
  { ID: 80, NAME: "Hong Kong", CODE: "HK" },
  { ID: 81, NAME: "Croatia", CODE: "HR" },
  { ID: 82, NAME: "Haiti", CODE: "HT" },
  { ID: 83, NAME: "Hungary", CODE: "HU" },
  { ID: 84, NAME: "Indonesia", CODE: "ID" },
  { ID: 85, NAME: "Ireland", CODE: "IE" },
  { ID: 86, NAME: "Israel", CODE: "IL" },
  { ID: 87, NAME: "India", CODE: "IN" },
  { ID: 88, NAME: "Iraq", CODE: "IQ" },
  { ID: 89, NAME: "Iran, Islamic Republic of", CODE: "IR" },
  { ID: 90, NAME: "Iceland", CODE: "IS" },
  { ID: 91, NAME: "Italy", CODE: "IT" },
  { ID: 92, NAME: "Jersey", CODE: "JE" },
  { ID: 93, NAME: "Jamaica", CODE: "JM" },
  { ID: 94, NAME: "Jordan", CODE: "JO" },
  { ID: 95, NAME: "Japan", CODE: "JP" },
  { ID: 96, NAME: "Kenya", CODE: "KE" },
  { ID: 97, NAME: "Cambodia", CODE: "KH" },
  { ID: 98, NAME: "Korea, Democratic People's Republic of", CODE: "KP" },
  { ID: 99, NAME: "Korea, Republic of", CODE: "KR" },
  { ID: 100, NAME: "Kuwait", CODE: "KW" },
  { ID: 101, NAME: "Kazakhstan", CODE: "KZ" },
  { ID: 102, NAME: "Lebanon", CODE: "LB" },
  { ID: 103, NAME: "Saint Lucia", CODE: "LC" },
  { ID: 104, NAME: "Liechtenstein", CODE: "LI" },
  { ID: 105, NAME: "Sri Lanka", CODE: "LK" },
  { ID: 106, NAME: "Lithuania", CODE: "LT" },
  { ID: 107, NAME: "Luxembourg", CODE: "LU" },
  { ID: 108, NAME: "Latvia", CODE: "LV" },
  { ID: 109, NAME: "Libya", CODE: "LY" },
  { ID: 110, NAME: "Morocco", CODE: "MA" },
  { ID: 111, NAME: "Moldova, Republic of", CODE: "MD" },
  { ID: 112, NAME: "Saint Martin (French part)", CODE: "MF" },
  { ID: 113, NAME: "Madagascar", CODE: "MG" },
  { ID: 114, NAME: "Macedonia, the former Yugoslav Republic of", CODE: "MK" },
  { ID: 115, NAME: "Mali", CODE: "ML" },
  { ID: 116, NAME: "Myanmar", CODE: "MM" },
  { ID: 117, NAME: "Mongolia", CODE: "MN" },
  { ID: 118, NAME: "Macao", CODE: "MO" },
  { ID: 119, NAME: "Mauritania", CODE: "MR" },
  { ID: 120, NAME: "Malta", CODE: "MT" },
  { ID: 121, NAME: "Malawi", CODE: "MW" },
  { ID: 122, NAME: "Mexico", CODE: "MX" },
  { ID: 123, NAME: "Malaysia", CODE: "MY" },
  { ID: 124, NAME: "Namibia", CODE: "NA" },
  { ID: 125, NAME: "Niger", CODE: "NE" },
  { ID: 126, NAME: "Nigeria", CODE: "NG" },
  { ID: 127, NAME: "Netherlands", CODE: "NL" },
  { ID: 128, NAME: "Norway", CODE: "NO" },
  { ID: 129, NAME: "Nepal", CODE: "NP" },
  { ID: 130, NAME: "New Zealand", CODE: "NZ" },
  { ID: 131, NAME: "Oman", CODE: "OM" },
  { ID: 132, NAME: "Panama", CODE: "PA" },
  { ID: 133, NAME: "Peru", CODE: "PE" },
  { ID: 134, NAME: "French Polynesia", CODE: "PF" },
  { ID: 135, NAME: "Papua New Guinea", CODE: "PG" },
  { ID: 136, NAME: "Philippines", CODE: "PH" },
  { ID: 137, NAME: "Pakistan", CODE: "PK" },
  { ID: 138, NAME: "Poland", CODE: "PL" },
  { ID: 139, NAME: "Puerto Rico", CODE: "PR" },
  { ID: 140, NAME: "Palestine", CODE: "PS" },
  { ID: 141, NAME: "Portugal", CODE: "PT" },
  { ID: 142, NAME: "Paraguay", CODE: "PY" },
  { ID: 143, NAME: "Qatar", CODE: "QA" },
  { ID: 144, NAME: "Reunion", CODE: "RE" },
  { ID: 145, NAME: "Romania", CODE: "RO" },
  { ID: 146, NAME: "Serbia", CODE: "RS" },
  { ID: 147, NAME: "Russian Federation", CODE: "RU" },
  { ID: 148, NAME: "Saudi Arabia", CODE: "SA" },
  { ID: 149, NAME: "Sweden", CODE: "SE" },
  { ID: 150, NAME: "Singapore", CODE: "SG" },
  { ID: 151, NAME: "Slovenia", CODE: "SI" },
  { ID: 152, NAME: "Slovakia", CODE: "SK" },
  { ID: 153, NAME: "Senegal", CODE: "SN" },
  { ID: 154, NAME: "El Salvador", CODE: "SV" },
  { ID: 155, NAME: "Swaziland", CODE: "SZ" },
  { ID: 156, NAME: "French Southern Territories", CODE: "TF" },
  { ID: 157, NAME: "Thailand", CODE: "TH" },
  { ID: 158, NAME: "Tajikistan", CODE: "TJ" },
  { ID: 159, NAME: "Tunisia", CODE: "TN" },
  { ID: 160, NAME: "Turkey", CODE: "TR" },
  { ID: 161, NAME: "TrinIDad and Tobago", CODE: "TT" },
  { ID: 162, NAME: "Taiwan", CODE: "TW" },
  { ID: 163, NAME: "Tanzania, United Republic of", CODE: "TZ" },
  { ID: 164, NAME: "Ukraine", CODE: "UA" },
  { ID: 165, NAME: "Uganda", CODE: "UG" },
  { ID: 166, NAME: "United States", CODE: "US" },
  { ID: 167, NAME: "Uruguay", CODE: "UY" },
  { ID: 168, NAME: "Uzbekistan", CODE: "UZ" },
  { ID: 169, NAME: "Venezuela, Bolivarian Republic of", CODE: "VE" },
  { ID: 170, NAME: "Vietnam", CODE: "VN" },
  { ID: 171, NAME: "Yemen", CODE: "YE" },
  { ID: 172, NAME: "South Africa", CODE: "ZA" },
  { ID: 173, NAME: "Zambia", CODE: "ZM" },
] as const;

export type CountryCode = (typeof COUNTRIES)[number]["CODE"];
